import { computed } from "vue";
import type { RouteLocationRaw } from "vue-router";
import { Schuljahresabschnitt } from "@core";
import { RouteData, type RouteStateInterface } from "~/router/RouteData";
import { api } from "~/router/Api";
import { routeSchueler } from "~/router/apps/schueler/RouteSchueler";
import { RouteManager, routerManager } from "../RouteManager";
import type { AbschnittAuswahlDaten } from "@ui";

export interface RouteStateApp extends RouteStateInterface {
	idSchuljahresabschnitt: number;
	view: any;
}

const defaultState = <RouteStateApp>{
	idSchuljahresabschnitt: -1,
	view: routeSchueler,
};

export class RouteDataApp extends RouteData<RouteStateApp> {

	public constructor() {
		super(defaultState);
	}

	public async leave() {
		this._state.value = this._defaultState;
	}

	aktAbschnitt = computed<Schuljahresabschnitt>(() => api.mapAbschnitte.value.get(this.idSchuljahresabschnitt) || api.abschnitt);

	public setAbschnitt = async (abschnitt: Schuljahresabschnitt) => {
		// TODO was tun, wenn das akt Halbjahr neu gesetzt wurde?
		const node = routerManager.getRouteNode();
		const params = { ... routerManager.getRouteParams() };
		params.idSchuljahresabschnitt = String(abschnitt.id);
		const locationRaw: RouteLocationRaw = {};
		locationRaw.name = node!.name;
		locationRaw.params = params;
		await RouteManager.doRoute(locationRaw);
	};

	/**
	 * Getter für die Informationen, welche für eine Schuljahresabschnittsauswahl benötigt werden.
	 */
	public getSchuljahresabschnittsauswahl(istAktiv: boolean): AbschnittAuswahlDaten {
		return <AbschnittAuswahlDaten>{
			aktiv: istAktiv, // && api.mode !== ServerMode.STABLE,
			abschnitte: api.mapAbschnitte.value,
			aktuell: this.aktAbschnitt.value,
			schule: api.mapAbschnitte.value.get(api.schuleStammdaten.idSchuljahresabschnitt) ?? new Schuljahresabschnitt(),
			set: this.setAbschnitt,
		};
	}

	/**
	 * Setzt den Schuljahresabschnitt und triggert damit das Laden der Defaults für diesen Abschnitt
	 *
	 * @param {number} idSchuljahresabschnitt   die ID des Schuljahresabschnitts
	 */
	public async setSchuljahresabschnitt(idSchuljahresabschnitt: number) {
		// Prüfe, ob sich der Schuljahresabschnitt geändert hat.
		if (this._state.value.idSchuljahresabschnitt === idSchuljahresabschnitt) {
			return;
		}
		// Setze den Schuljahresabschnitt
		this.setPatchedState({ idSchuljahresabschnitt });
	}

	public get idSchuljahresabschnitt() {
		return this._state.value.idSchuljahresabschnitt;
	}

}

